<template>
    <v-container fluid>
        <v-row
            align="center"
            justify="center"
            no-gutters
        >
            <v-col
                cols="12"
                lg="4"
            >
                <AreaOrProviderSelector @selection-changed="filterSelectionChanged"></AreaOrProviderSelector>
            </v-col>
        </v-row>

        <v-row
            align="start"
            no-gutters
            v-masonry
        >
            <!----=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-Billings--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
            <!--
            <v-col
                cols="12"
                justify="center"
                lg="6"
                md="12"
                xl="4"
                v-if="
                    accessCrud.some((x) => x.e && x.e == 'Billing') &&
                    accessCrud.find((x) => x.e == 'Billing').r
                "
            >
                <Billings @hook:mounted="redrawMasonry" />
            </v-col>
            -->
            <!----=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-ManagementCaseAdministrator--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
            <v-col
                cols="12"
                justify="center"
                lg="6"
                md="12"
                v-if="
                    accessCrud.some((x) => x.e && x.e == 'Patient') &&
                    accessCrud.find((x) => x.e == 'Patient').r
                "
                xl="4"
            >
                <ManagementCaseAdministratorWidget
                    :selected-area-provider-filter="areaProviderFilter"
                    @hook:mounted="redrawMasonry"
                />
            </v-col>
            <!----=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-ManagementAreaRepresentative--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
            <v-col
                cols="12"
                justify="center"
                lg="6"
                md="12"
                v-if="
                    accessCrud.some((x) => x.e && x.e == 'Incident') &&
                    accessCrud.find((x) => x.e == 'Incident').r
                "
                xl="4"
            >
                <ManagementAreaRepresentativeWidget
                    :selected-area-provider-filter="areaProviderFilter"
                    @hook:mounted="redrawMasonry"
                />
            </v-col>
            <!----=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-ManagementAccounts--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
            <v-col
                cols="12"
                justify="center"
                lg="6"
                md="12"
                v-if="
                    accessCrud.some((x) => x.e && x.e == 'Account') &&
                    accessCrud.find((x) => x.e == 'Account').r
                "
                xl="4"
            >
                <ManagementAccountsWidget
                    :selected-area-provider-filter="areaProviderFilter"
                    @hook:mounted="redrawMasonry"
                />
            </v-col>
            <!----=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-ManagementClaimSubmission--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
            <v-col
                cols="12"
                justify="center"
                lg="6"
                md="12"
                v-if="
                    accessCrud.some((x) => x.e && x.e == 'Claim') &&
                    accessCrud.find((x) => x.e == 'Claim').r
                "
                xl="4"
            >
                <ManagementClaimSubmissionWidget
                    :selected-area-provider-filter="areaProviderFilter"
                    @hook:mounted="redrawMasonry"
                />
            </v-col>
            <!----=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-ManagementClaimPayments--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
            <v-col
                cols="12"
                justify="center"
                lg="6"
                md="12"
                v-if="
                    accessCrud.some((x) => x.e && x.e == 'Claim') &&
                    accessCrud.find((x) => x.e == 'Claim').r
                "
                xl="4"
            >
                <ManagementClaimPaymentsWidget
                    :selected-area-provider-filter="areaProviderFilter"
                    @hook:mounted="redrawMasonry"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
//import Accounts from "../components/widgets/ManagementDashboard/Accounts.vue";
//import AccountAgeingOld from "../components/widgets/AccountAgeingOld";
//import Incidents from "../components/widgets/ManagementDashboard/Incidents.vue";
//import Claims from "../components/widgets/ManagementDashboard/Claims.vue";
//import Patients from "../components/widgets/ManagementDashboard/Patients.vue";
import AreaOrProviderSelector from "../components/AreaOrProviderSelector.vue";
import ManagementCaseAdministratorWidget from "../components/widgets/ManagementDashboard/ManagementCaseAdministratorWidget.vue";
import ManagementAreaRepresentativeWidget from "../components/widgets/ManagementDashboard/ManagementAreaRepresentativeWidget.vue";
import ManagementAccountsWidget from "../components//widgets/ManagementDashboard/ManagementAccountsWidget.vue";
import ManagementClaimSubmissionWidget from "../components/widgets/ManagementDashboard/ManagementClaimSubmissionWidget.vue";
import ManagementClaimPaymentsWidget from "../components/widgets/ManagementDashboard/ManagementClaimPaymentsWidget.vue";
//import Billings from "../components/widgets/Billings.vue";
export default {
    name: "ManaDashboard",
    data: () => ({
        accessCrud: [],
        isAnyReports: true,
        selectedAreaProviderFilter: { areaId: 0, providerId: 0 }
        //
    }),
    created: async function() {
        this.accessCrud = await this.$store.dispatch(
            "authentication/getAccess"
        );
    },
    mounted: function() {
        // if (typeof this.$redrawVueMasonry === "function") {
        this.$redrawVueMasonry();
        //}
        /*
if(this.accessCrud.some(x => x.e && x.e == 'Account') && this.accessCrud.find(x => x.e == 'Account').r)
        this.$store
            .dispatch("accounts/getAgeingAccounts")
            .then(accountsResponse => {
                this.accounts = accountsResponse;
            });

            if(this.accessCrud.some(x => x.e && x.e == 'OldIncident') && this.accessCrud.find(x => x.e == 'OldIncident').r)
        this.$store
            .dispatch("deprecatedincidents/getageing")
            .then(deprecatedincidentsResponse => {
                this.oldIncidents = deprecatedincidentsResponse;
            });

    if(this.accessCrud.some(x => x.e && x.e == 'Incident') && this.accessCrud.find(x => x.e == 'Incident').r)
        this.$store.dispatch("incidents/getageing").then(incidentsResponse => {
            this.incidents = incidentsResponse;
        });

if(this.accessCrud.some(x => x.e && x.e == 'Customer') && this.accessCrud.find(x => x.e == 'Customer').r)
        this.$store
            .dispatch("customers/getAccisureDashboard")
            .then(accisureResponse => {
                this.accisure = accisureResponse;
            });
            */
    },
    components: {
        //Accounts,
        AreaOrProviderSelector,
        //Incidents,
        //Claims,
        //Patients,
        ManagementCaseAdministratorWidget,
        ManagementAreaRepresentativeWidget,
        ManagementAccountsWidget,
        ManagementClaimSubmissionWidget,
        ManagementClaimPaymentsWidget,
        //Billings
    },
    computed: {
        areaProviderFilter: function() {
            return this.selectedAreaProviderFilter;
        }
    },
    methods: {
        filterSelectionChanged(filtering) {
            this.selectedAreaProviderFilter = filtering;
            /*
            this.areaId = filtering.areaId;
            this.providerId = filtering.providerId;
            */
        },
        areAnyReportsAvailable(areAnyReportsAvailable) {
            this.isAnyReports = areAnyReportsAvailable;
        },
        redrawMasonry() {
            this.$redrawVueMasonry();
        }
        //--------------------
    }
};
</script>

<style lang="stylus" scoped>
c-block-w = 73px;
c-block-h = 55px;

/deep/.ageing-stat {
    width: c-block-w;
    height: c-block-h;

    // border-radius: 2px !important
    &.ageing-stat-wide {
        width: c-block-w * 1.45;
    }

    .header {
        position: absolute;
        left: 4px;
        top: 0px;
    }

    .stat {
        margin-top: 5px;
        margin-bottom: -5px;
        line-height: c-block-h;
    }
}

/deep/.theme--light {
    .base-background {
        background: #FFFFFF;
    }
}

/deep/.theme--dark {
    .base-background {
        background: #121212;
    }
}

/*
/deep/.dashboard-card
    background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1))
*/
</style>
